var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "209px",
    height: "55px",
    viewBox: "0 0 209 55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "full_logo_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "full_logo_black",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 6.774000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.096,43.159 C31.096,43.159 33.073,39.907 32.624,37.459 C32.175,35.011 29.624,31.242 29.624,31.242 L18.324,11.819 L25.501,0 L50.868,43.163 L31.099,43.163 L31.096,43.159 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.466,27.073 L0,43.227 L22.054,43.227 C20.1596168,42.7082525 18.4727785,41.6146725 17.226,40.097 C15.208,37.59 9.466,27.073 9.466,27.073 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.000000, 0.000000)",
    fontFamily: "Poppins-ExtraBold, Poppins",
    fontSize: 23,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("text", {
    id: "ART"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "ART")), /*#__PURE__*/React.createElement("text", {
    id: "COLLECTION"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 47
  }, "COLLECTION")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogoBlack);
export default __webpack_public_path__ + "static/media/full_logo_black.a1d28e1ee392228793f1fb4d0595d098.svg";
export { ForwardRef as ReactComponent };